import React from 'react';
import classNames from 'classnames';
import Highlighter from 'react-highlight-words';
import ListSearch from '../list/ListSearch';

const AccountSearch = props => {
  const renderSuggestion = (suggestion, { isHighlighted, query }) => {
    const result = {};

    ['itemid', 'Description'].forEach((part) => {
      result[part] = suggestion[part];
      if (result[part]) {
        result[part] = (
          <Highlighter
            autoEscape
            highlightClassName="hl"
            searchWords={query.replace(':', '').split(/\s/)}
            textToHighlight={`${suggestion[part]}`}
          />
        );
      }
    });

    if (suggestion.InterCompany !== null) {
      const className = classNames({
        'account-suggestion': true,
        flagged: !isHighlighted,
      });

      return (
        <div className={className} title="InterCompany Account">
          <div><i className="zmdi zmdi-swap" /> {result.itemid}: {result.Description}</div>
        </div>
      );
    }

    return (
      <div className="account-suggestion">
        <div>{result.itemid}: {result.Description}</div>
      </div>
    );
  };

  return (
    <ListSearch
      {...props}
      renderSuggestion={renderSuggestion}
    />
  );
};

export default AccountSearch;
